/*
  FormattedMessages.js - FormattedMessages for Sent Component
*/

// NPM MODULES
import React from 'react';
import { FormattedMessage } from 'react-intl';

const FormattedMessages = {
  backText: (
    <FormattedMessage
      id="AllSends.backText"
      defaultMessage="Back to Sent List"
    />
  ),
  cancelPendingMessage: (
    <FormattedMessage
      id="AllSends.cancelPendingMessage"
      defaultMessage="Cancel Pending Message"
    />
  ),
  queuedHeader: (
    <FormattedMessage id="AllSends.queuedHeader" defaultMessage="Queued" />
  ),
  deliveredHeader: (
    <FormattedMessage
      id="AllSends.deliveredHeader"
      defaultMessage="Delivered"
    />
  ),
  toHeader: <FormattedMessage id="AllSends.toHeader" defaultMessage="To" />,
  fromHeader: <FormattedMessage id="AllSends.toHeader" defaultMessage="From" />,
  statusHeader: (
    <FormattedMessage id="AllSends.statusHeader" defaultMessage="Status" />
  ),
  errorCodeHeader: (
    <FormattedMessage
      id="AllSends.errorCodeHeader"
      defaultMessage="Error Code"
    />
  ),
  errorTextHeader: (
    <FormattedMessage
      id="AllSends.errorTextHeader"
      defaultMessage="Error Text"
    />
  ),
  encodingHeader: (
    <FormattedMessage
      id="AllSends.encodingHeader"
      defaultMessage="Message Encoding"
    />
  ),
  delDevice: (
    <FormattedMessage
      id="AllSends.delDevice"
      defaultMessage="Delivery Device"
    />
  ),
  repDevice: (
    <FormattedMessage id="AllSends.delDevice" defaultMessage="Reply Device" />
  ),
  messageHeader: (
    <FormattedMessage id="AllSends.messageHeader" defaultMessage="Message" />
  ),
  clear: (
    <FormattedMessage id="AllSends.Clear" defaultMessage="Clear Filters" />
  ),
  allMessagesTitle: (
    <FormattedMessage
      id="AllSends.allMessagesTitle"
      defaultMessage="All Messages"
    />
  ),
  dateTimeText: (
    <FormattedMessage id="Websms.DateTimeText" defaultMessage="Date/Time" />
  ),
  user: <FormattedMessage id="Websms.User" defaultMessage="User" />,
  fromText: <FormattedMessage id="websms.FromText" defaultMessage="From" />,
  toText: <FormattedMessage id="Websms.ToText" defaultMessage="To" />,
  country: <FormattedMessage id="Websms.country" defaultMessage="Country" />,

  status: <FormattedMessage id="Websms.Status" defaultMessage="Status" />,
  errorCode: (
    <FormattedMessage id="Websms.ErrorCode" defaultMessage="ErrorCode" />
  ),
  parameters: (
    <FormattedMessage id="Websms.Parameters" defaultMessage="Parameters" />
  ),
  duration: (
    <FormattedMessage id="Websms.Duration" defaultMessage="Duration (ms)" />
  ),
};

export default FormattedMessages;
